import moment from 'moment';

export const dateStrToFormat = (dataStr, format = 'YYYY-MM-DD HH:mm:ss') => {
  if (!dataStr) {
    return '';
  }
  return moment(dataStr).format(format);
};

export const noDataValue = (dataStr) => {
  if (dataStr === 0) {
    return 0;
  } else if (!dataStr) {
    return '-';
  }
  return dataStr;
};
